import { useCallback } from 'react'

import { useProfile, getAccessToken } from '../../../security'
import { buildDocumentContentUrl } from '../../../util/file'
import { FetchDocumentContent } from './document-upload-context-types'

// Fetches a document's content as a blob, using the current user's airportId and access token.
const useFetchDocumentContent = (): FetchDocumentContent => {
  const { airportId } = useProfile()

  return useCallback(
    async (document, options) => {
      const response = await fetch(buildDocumentContentUrl(airportId, document.id, { download: options?.download }), {
        headers: { Authorization: `Bearer ${getAccessToken()}` },
      })

      if (!response.ok) {
        throw new Error(`Failed to fetch document content (status ${response.status})`)
      }

      return response.blob()
    },
    [airportId],
  )
}

export default useFetchDocumentContent
